module.exports = "/_next/static/images/CollectImage-bacfa270b3dc36b805a190ba803bdaa9.webp";